var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c("div", { attrs: { id: "card-container" } }, [
              _c("div", { staticClass: "input-form" }, [
                _c("div", { staticClass: "card-design" }, [
                  _c("div", [
                    _c("div", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.$t("system.user.query")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "all-forms" }, [
                      _c(
                        "div",
                        { staticClass: "form" },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("system.menu.placeholder")) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("SMS.pleaseEnterText")
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.fetchData($event)
                              }
                            },
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "searchButton" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-search"
                          },
                          on: { click: _vm.fetchData }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("system.user.query")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c("div", { staticClass: "otherActions" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "addEditOrDelete" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasAddPermission,
                            expression: "hasAddPermission"
                          }
                        ],
                        attrs: {
                          plain: _vm.$store.getters.plainConf,
                          type: "success",
                          icon: "el-icon-plus",
                          disabled: _vm.currentTree.length > 1
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDialog("add")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.add")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasUpdatePermission,
                            expression: "hasUpdatePermission"
                          }
                        ],
                        attrs: {
                          plain: _vm.$store.getters.plainConf,
                          type: "warning",
                          icon: "el-icon-edit",
                          disabled: _vm.currentTree.length != 1
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDialog("edit")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.edit")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasDeletePermission,
                            expression: "hasDeletePermission"
                          }
                        ],
                        attrs: {
                          plain: _vm.$store.getters.plainConf,
                          type: "danger",
                          icon: "el-icon-delete",
                          disabled: _vm.currentTree.length == 0
                        },
                        on: { click: _vm.handleMultipleDelete }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.delete")))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tree-diagram", staticStyle: { width: "100%" } },
                [
                  _c("div", { staticClass: "text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("system.menu.menuType1")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "scrollbar" },
                    [
                      _c(
                        "el-scrollbar",
                        { attrs: { "wrap-class": "scrollbar-wrapper" } },
                        [
                          _c("el-tree", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            ref: "tree",
                            attrs: {
                              "check-strictly": true,
                              data: _vm.tree,
                              "show-checkbox": "",
                              "node-key": "id",
                              "highlight-current": "",
                              props: _vm.treeProps,
                              "filter-node-method": _vm.filterNode
                            },
                            on: {
                              check: _vm.handleCheck,
                              "node-click": _vm.viewDate
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-preview" },
                    [
                      _c("div", { staticClass: "view" }, [
                        _vm._v(" " + _vm._s(_vm.$t("system.user.bView")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: true,
                            "label-position": "left",
                            "label-width": "130px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.menu.parentMenuID"),
                                prop: "parentId"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.viewData.parentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.viewData, "parentId", $$v)
                                  },
                                  expression: "viewData.parentId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.menu.menuName"),
                                prop: "menuName"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.viewData.menuName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.viewData, "menuName", $$v)
                                  },
                                  expression: "viewData.menuName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.menu.menuType"),
                                prop: "type"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "0" },
                                  model: {
                                    value: _vm.viewData.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.viewData, "type", $$v)
                                    },
                                    expression: "viewData.type"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("system.menu.menuType1"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  model: {
                                    value: _vm.viewData.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.viewData, "type", $$v)
                                    },
                                    expression: "viewData.type"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("system.menu.menuType2"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.viewData.type != 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("system.menu.menuIcon")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.viewData.icon,
                                      callback: function($$v) {
                                        _vm.$set(_vm.viewData, "icon", $$v)
                                      },
                                      expression: "viewData.icon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formData.type != 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "URL" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.viewData.url,
                                      callback: function($$v) {
                                        _vm.$set(_vm.viewData, "url", $$v)
                                      },
                                      expression: "viewData.url"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.menu.menuPermission")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.viewData.perms,
                                  callback: function($$v) {
                                    _vm.$set(_vm.viewData, "perms", $$v)
                                  },
                                  expression: "viewData.perms"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.viewData.type != 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("system.menu.menuListOrder"),
                                    prop: "orderNum"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.viewData.orderNum,
                                      callback: function($$v) {
                                        _vm.$set(_vm.viewData, "orderNum", $$v)
                                      },
                                      expression: "viewData.orderNum"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "dialog"
        },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                id: "dialog",
                title: _vm.formTitle,
                visible: _vm.showDialog,
                width: "600px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showDialog = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card" },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formTitle) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close" }, [
                      _c("i", {
                        staticClass: "el-icon-close",
                        on: { click: _vm.closeDialog }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.formData,
                        "label-position": "left",
                        "label-width": "130px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.menu.parentMenuID"),
                            prop: "parentId"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.formData.parentId,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "parentId", $$v)
                              },
                              expression: "formData.parentId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.menu.menuName"),
                            prop: "menuName"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.menuName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "menuName", $$v)
                              },
                              expression: "formData.menuName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.menu.menuType"),
                            prop: "type"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "0" },
                              model: {
                                value: _vm.formData.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "type", $$v)
                                },
                                expression: "formData.type"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("system.menu.menuType1")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.formData.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "type", $$v)
                                },
                                expression: "formData.type"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("system.menu.menuType2")))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.type != 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("system.menu.menuIcon") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formData.icon,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "icon", $$v)
                                  },
                                  expression: "formData.icon"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.type != 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "URL" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.formData.url,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "url", $$v)
                                  },
                                  expression: "formData.url"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("system.menu.menuPermission") }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.perms,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "perms", $$v)
                              },
                              expression: "formData.perms"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.type != 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.menu.menuListOrder"),
                                prop: "orderNum"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  oninput:
                                    "javascript:this.value=this.value.replace(/\\D/g,'')"
                                },
                                model: {
                                  value: _vm.formData.orderNum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "orderNum", $$v)
                                  },
                                  expression: "formData.orderNum"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "confirm-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formButton) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }